<cap-input-mask
    type="text"
    [class]="to.styleClass"
    [formlyAttributes]="field"
    [formControl]="formControl"
    [placeholder]=""
    [mask]="to.mask"
></cap-input-mask>
